import { render, staticRenderFns } from "./CorrectAnswerComponent.vue?vue&type=template&id=12e58a72&scoped=true"
import script from "./CorrectAnswerComponent.vue?vue&type=script&lang=js"
export * from "./CorrectAnswerComponent.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=12e58a72&prod&scoped=true&lang=css&external"
import style1 from "./CorrectAnswerComponent.vue?vue&type=style&index=1&id=12e58a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e58a72",
  null
  
)

export default component.exports